export default "__VITE_PUBLIC_ASSET__4d4f0302__"